import React, { Component } from 'react'
import { Form } from 'redux-form'
import { Dots, Dot } from 'components/Dots'
import sMarg from 'styles/modules/margins.scss'
import analytics from 'features/Analytics/Analytics.utils'
import showConfirmModal from 'features/Modal/ConfirmModal/ConfirmModal.action'
import { moment } from 'features/Moment'

import { Container } from 'components/Layout'
import HeadingBanner from 'components/Text/HeadingBanner'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'

export default class NumbersCommonForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 0,
      steps: [],
    }
  }

  getTrackType(numberType) {
    switch (numberType) {
      case '1300':
      case '1800':
        return 'Classic'

      case 'local':
      case 'mobile':
      case 'global':
        return 'Ultimate'
    }

    return numberType
  }

  trackAnalytics(data, numberType) {
    const crmService = data.action.payload.data?.service

    const type = this.getTrackType(numberType)

    analytics.track({
      action: 'track',
      event: `Create - ${type}`,
      properties: {
        category: 'Create Number',
        label: type,
        value: crmService?.monthlyCharge || 0,
      },
    })

    return data
  }

  trackAnalyticsError(error, formData) {
    analytics.track('Numbers - Create Error', {
      formData,
      error,
    })
  }

  submit(formData) {
    const { createNumber, clearSubmitErrors, numberType } = this.props
    const { step, steps } = this.state

    if (step === steps.length - 1) {
      return createNumber(formData)
        .then(data => this.trackAnalytics(data, numberType))
        .then(data => this.showCreateNumberConfirmation(data))
        .catch(error => this.trackAnalyticsError(error, formData))
    }

    this.nextStep()
    clearSubmitErrors()
  }

  showCreateNumberConfirmation = data => {
    const { dispatch, push, reset, onCancel } = this.props
    const crmCase = data.action.payload.data.case
    const crmService = data.action.payload.data.service
    const plannedDeliveryDate = moment(crmCase.plannedDeliveryDate).format('DD MMM YYYY')

    const modalOptions = !crmService
      ? {
          title: 'We are processing your request',
          message: `
              You will be able to register mobile numbers after approval of provided documents.
              Planned delivery date: ${plannedDeliveryDate}
            `,
        }
      : {
          title: 'Great News, your Simply Awesome Business Number is underway.',
          message: `
              Number: ${crmService.number}<br>
              Corresponding case: ${crmCase.caseId}<br>
              Planned delivery date: ${plannedDeliveryDate}<br><br>
              Please note until you receive your Completion Advice via email we cannot confirm number availability.
              It’s best to hold off any advertising using your new number until you get the final confirmation email.
            `,
        }

    dispatch(
      showConfirmModal({
        ...modalOptions,
        textSize: 'sm',
        hideClose: true,
        noClickClose: true,
      })
    ).then(() => {
      reset()
      onCancel()
      push('/dashboard/numbers')
    })
  }

  nextStep = () => {
    const { step } = this.state
    this.setState({ step: step + 1 })
  }

  prevStep = () => {
    const { step } = this.state
    this.setState({ step: step - 1 })
  }

  render() {
    const { handleSubmit, heading, subHeading } = this.props
    const { steps, step } = this.state

    if (steps.length === 0) {
      return null
    }

    const currentStep = steps[step]

    const headingValue =
      typeof currentStep.heading === 'function'
        ? currentStep.heading(this.props)
        : currentStep.heading || heading

    const subHeadingValue =
      typeof currentStep.subHeading === 'function'
        ? currentStep.subHeading(this.props)
        : currentStep.subHeading || subHeading

    return (
      <div>
        <HeadingBanner filled>
          <h2 className={cn(sText.heading3, sText.accent)}>{headingValue}</h2>
          <div className={sText.descrip1}>{subHeadingValue}</div>
        </HeadingBanner>

        <Container paddingTop paddingBottom className="sm">
          <Dots className={sMarg.mb60to30}>
            {steps.map((undefined, idx) => (
              <Dot key={idx} active={step === idx} />
            ))}
          </Dots>
          {currentStep.wrapInForm ? (
            <Form onSubmit={handleSubmit(this.submit)}>
              <currentStep.Component {...this.props} />
            </Form>
          ) : (
            <currentStep.Component {...this.props} />
          )}
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersForm/NumbersCommonForm.jsx